<template>
  <span title="阅读">
    <a-icon :style="{fontSize: size}" v-if="voiceStatus == 2" type="pause-circle" theme="twoTone" @click="voice.pause()" />
    <a-icon :style="{fontSize: size}" v-if="voiceStatus == 0" type="sound" theme="twoTone" @click="requestVoice" />
    <a-icon :style="{fontSize: size}" v-if="voiceStatus == 1" type="loading" />

  </span>
</template>

<script>
import { postAction } from '@/api/manage'
export default {
  name: 'Voice',
  props:{
    text:{
      type: String,
      require: true
    },
    size: {
      type: String,
      default: '12px'
    },
  },
  data() {
    return {
      voice: new Audio(), //读题
      voiceStatus: 0, //0停止 1加载 2播放中
    }
  },
  created() {
    let that = this
    this.voice.autoplay = true
    this.voice.onplay = function () {
      that.voiceStatus = 2
    }
    this.voice.onended = function () {
      that.voiceStatus = 0
    }
    this.voice.onpause = function () {
      that.voiceStatus = 0
    }
  },
  mounted(){
    let that = this
    window.document.addEventListener("viocePause", function () {
      that.voice.pause()
    })
  },
  methods: {
    read(text){
      this.text = text
      this.requestVoice()
    },
    requestVoice() {
      console.log(this.text);

      this.voiceStatus = 1
      window.document.dispatchEvent(new CustomEvent('viocePause'));
      postAction('/teaching/teachingQuestion/requestVoice', { text: this.text }).then((res) => {
        this.voiceStatus = 0
        if(res){
          this.voice.src = res
          this.voice.play()
        }
      })
    },
  },
}
</script>

<style>
</style>